<script>
    import {push} from 'svelte-spa-router';
    push('/basket')
</script>

<h4>Nothing here...</h4>